import { formBundleCriteriaApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const FORM_BUNDLES_AFTER_SUBMIT_ACTION_TYPE = createNamedActions('formBundlesAfterSubmit', {
  GET_CRITERIA_SCHEMA: 'GET_CRITERIA_SCHEMA',
});

export const getFormBundleSchemaParamsAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await formBundleCriteriaApi.getSchema();

  return dispatch({
    type: FORM_BUNDLES_AFTER_SUBMIT_ACTION_TYPE.GET_CRITERIA_SCHEMA,
    payload: data,
  });
});
